export const TOAST_DURATION: number = 3000
export const ROWS_PER_PAGE: number[] = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
